// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import config from '../../config/config';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';
import { ApiResponse, ApplicationRecord } from './types/types';

// Define a service using a base URL and expected endpoints
export const applicationsAPI = createApi({
  reducerPath: 'applicationsAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  endpoints: (builder) => ({
    getApplications: builder.query<ApplicationRecord[], void>({
      query: () => ({
        url: `/auth/application`,
        method: 'GET',
      }),
      transformResponse: (response: ApiResponse<ApplicationRecord[]>) => response.body,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetApplicationsQuery } = applicationsAPI;
